import { atom } from 'recoil';
import defaultAvailablePoints from 'ProjectManager/Project/Introductions/Common/recoil/availablePoints/defaultAvailablePoints';

const availablePointsAtom = atom({
    key: 'projectManagement_introduction_available_points',
    default: defaultAvailablePoints,
});

export default availablePointsAtom;
